<style lang="less" scoped>
@import '../../../style/common/variable';
.zlk{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 10px;}
.national{width: 1200px;}
.zero{display: flex;flex-direction: column;}
.first{display: flex;justify-content:space-between;width: 1200px;margin:auto;}
.second{display: flex;flex-direction: column;width: 810px;margin-right: 40px;}
.fourth{display: flex;justify-content:space-between;
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 24px;color: rgb(25, 159, 248);}
  .swiperImg{margin-right: 10px;padding-top: 5px;}
  .newsKYZXvue{text-align: left;margin-top: 5px;}
}
.third{display: flex;flex-direction: column;width: 350px;
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 24px;color: rgb(25, 159, 248);}
}
.classification{margin: 0px 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.category{margin-left: -10px;margin-top: 5px;}
.country{margin-top: 24px;
  img{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;}
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 22px;color: rgb(25, 159, 248);}
}
.flagCard{margin-left: -15px;}
.hotReading{margin-top: 30px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: -2px;font-size: 19px;color: rgb(25, 159, 248);}
}
.hotReadingList{margin-left: -36px;margin-top: 0px;text-align: left;}
.sjgx{width: 1200px; margin: 40px auto;display: flex; flex-direction: column;
  .iconfont{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 22px;color: rgb(25, 159, 248);}
  .select{width: 100%;display: flex;justify-content: space-between;height: 65px;}
  .label{color:#707070}

  .cardlist{width: 100%;margin: 0; padding: 0;margin-bottom:20px;
    li{display: flex;justify-content: space-between;height: 230px;margin-bottom: 25px; box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.16);border-radius: 4px;align-items:center;}
    li:hover{cursor: pointer;}
    .left{width:200px;height:200px; display:flex;flex-direction: column;align-items:center;
      img{vertical-align: middle;width: 80px;margin-top: 85px;}
    }
    .center{width: 620px; height:200px;display: flex;flex-direction: column;margin-top: 0px;}
    .title{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 24px;font-weight: 600;margin-top: 20px;margin-bottom: 10px;}
    .right{width: 280px; height:115pxpx;display: flex;flex-direction: column;top: 0;bottom: 0;margin: auto;}
    p{line-height: 10px;font-size: 18px;color:#707070;text-align: left;}
  }
  .input{width: 260px;font-size: 14px !important;}
  .button {width: 40px !important;height: 40px !important;cursor: pointer;font-size: 24px;background-color: white;border: solid rgb(219, 216, 216);border-width: 1px;border-radius: 5px;}
  .button:hover{color:#13569e;cursor: pointer;}
}
@media screen and (max-width: @max-screen){
  .zero{margin-top: .4rem}
  .third{display: none;}
  .first{width: 100vw;
    .fourth{flex-direction: column;justify-content: center;align-items: center; width: 100vw;}
  }
  .sjgx{width: 95vw;
    .select{display: flex;-webkit-box-pack: justify;height: auto;flex-direction: column;justify-content: space-evenly;align-items: flex-start;
      .type-item{display: flex; align-items: center; margin-bottom: .1rem;
        .label{margin-right: .1rem;}
      }
      .button{margin-left: .1rem; width: .4rem !important; height: .4rem !important; cursor: pointer; font-size: .2rem; background-color: white; border: solid #dbd8d8; border-width: 1px; border-radius: 5px;}
    }
    .cardlist{
      .left{width: 1rem;}
      .center{width: 3rem;
        .title{font-size: .2rem; margin-top: .1rem;}
        p{font-size: .14rem; line-height: .05rem;
        }
        .sjmc{ display: flex; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: .14rem; line-height: .3rem;width: 2.89rem;}
      }
      .right{margin-top: 1.6rem;margin-left: -3rem;
        p{font-size: .14rem; line-height: .05rem;}
      }
    }
  }
  .pagination{margin-left: .1rem;}
}

</style>

<template>
  <div class="zlk">
    <National class="national"></National>
    <div class="zero">
      <div class="first">
        <div class="second">
          <div class="fourth">
            <SwiperImg class="swiperImg" :swiperlist="swiperdata" :widthCSH="430" :heightCSH="320" @clickSwiper="goDetails"></SwiperImg>
            <NewsKYZX class="newsKYZXvue" :widthCSH="460" :heightCSH="310" :newsKYZXList="newsKYZXListdata" @clickNewsKyzx="goDetails"></NewsKYZX>
          </div>
          <router-view></router-view>
        </div>

        <div class="third">
          <div class="classification">
            <i class="iconfont icon-fenlei_" />
            <span>分类浏览 / Classified browsing</span>
          </div>
          <CategoryZLK class="category" @clickCategory="goTo"></CategoryZLK>
          <div class="country">
            <i class="iconfont icon-world" />
            <span>按国家浏览 / Country</span>
          </div>
          <FlagCard class="flagCard" @clickFlag="goKeywords"></FlagCard>
          <div class="hotReading">
            <i class="iconfont icon-zuirehotchunse" />
            <span>阅读排行 / Hot Reading</span>
          </div>
          <HotNewsList class="hotReadingList" :hotNewsList="readingdata" @clickHotNews="goDetails"></HotNewsList>
        </div>
      </div>

      <div class="sjgx">
        <div class="head">
          <h3 style="text-align:left;"><i class="iconfont icon-zixun"></i>数据共享 / Data sharing</h3>
        </div>
        <div class="select">
          <div class="type-item">
            <span class="label">类别: </span>
            <el-select v-model="LeiBie" placeholder="不限" :clearable="true">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="type-item">
            <span class="label">国家: </span>
            <el-select v-model="GuoJia" placeholder="不限" :clearable="true">
              <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="type-item">
            <span class="label">类型: </span>
            <el-select v-model="LeiXing" placeholder="不限" :clearable="true">
              <el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="type-item">
            <el-input class="input" v-model="Input" placeholder="请输入关键词"></el-input>
            <button class="button" @click="getList"><i class="el-icon-search"></i></button>
          </div>
        </div>
        <ul class="cardlist">
          <li v-for="(each, index) in cardlist" :key="index" @click="getSjgx(each)">
            <div class='left'>
              <img :src="each.src" alt="">
              <span style="color:#707070;line-height:40px">{{each.country}}</span>
            </div>
            <div class="center">
              <span class="title">{{each.title}}</span>
              <span class="sjmc">数据名称（中文）: {{each.sjmc}}</span>
              <p>语言类型: {{each.language}}</p>
              <p>关键词: {{each.keyword}}</p>
            </div>
            <div class="right">
              <p>
                <span>数据来源: {{each.source}}</span>
              </p>
              <p>
                <span>更新时间: {{(each.update * 1000) | formatDate()}}</span>
              </p>
            </div>
          </li>
        </ul>

        <div class="block">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange(this.form.count)"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="countSum">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 资料库首页公共部分
 */
import National from '../assembly/National.vue'
import SwiperImg from '../assembly/SwiperImg.vue'
import NewsKYZX from '../assembly/NewsKYZX.vue'
import CategoryZLK from '../assembly/CategoryZLK.vue'
import FlagCard from '../assembly/FlagCard.vue'
import HotNewsList from '../assembly/HotNewsList.vue'
import arrayFun from '../method/array.js'
import filters from '../method/filter.js'
export default {
  components: {
    National,
    SwiperImg,
    NewsKYZX,
    CategoryZLK,
    FlagCard,
    HotNewsList
  },
  name: '',
  mixins: [filters],
  data()
  {
    return {
      swiperdata: [], // SwiperImg数据
      newsKYZXListdata: [], // NewsKYZX数据
      readingdata: [], // 阅读排行数据
      options1: [
        { id: '选项1', name: '地形地质', value: 94 },
        { id: '选项2', name: '矿产资源', value: 95 },
        { id: '选项3', name: '投资环境', value: 96 },
        { id: '选项4', name: '法律法规', value: 97 },
        { id: '选项5', name: '其它', value: 98 }
      ],
      LeiBie: '',  // 类别
      options2: [
        { id: '选项1',  name: '中国',      value: '中国' },
        { id: '选项2',  name: '印度尼西亚', value: '印度尼西亚' },
        { id: '选项3',  name: '马来西亚',   value: '马来西亚' },
        { id: '选项4',  name: '菲律宾',     value: '菲律宾' },
        { id: '选项5',  name: '新加坡',     value: '新加坡' },
        { id: '选项6',  name: '泰国',       value: '泰国' },
        { id: '选项7',  name: '文莱',       value: '文莱' },
        { id: '选项8',  name: '越南',       value: '越南' },
        { id: '选项9',  name: '老挝',       value: '老挝' },
        { id: '选项10', name: '缅甸',       value: '缅甸' },
        { id: '选项11', name: '柬埔寨',     value: '柬埔寨' },
        { id: '选项12', name: '其他',       value: '其他' }
      ],
      GuoJia: '',  // 国家
      options3: [
        { id: '选项1', name: '图件', value: '图件' },
        { id: '选项2', name: '图表', value: '图表' },
        { id: '选项3', name: '文献', value: '文献' },
        { id: '选项4', name: '报告', value: '报告' }
      ],
      LeiXing: '',  // 类型
      Input: '',  // 输入关键字
      cardlist: [],  // 数据共享
      count: 10,
      pageSize: 10,
      currentPage: 1,
      countSum: null
    }
  },
  created()
  {
    this.getZlk()
    this.getList()
  },
  methods: {
    // 从数据库获取资料库首页公共部分数据
    getZlk()
    {
      // 今日要闻部分
      let paras = {cmd: 'query', _major: 11, _minor: 24, _exp: 'addtime>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.swiperdata = []
        this.newsKYZXListdata = []
        this.readingdata = []  // 阅读排行
        for (let i = 0; i < 5; i++)
          this.swiperdata.push({id: ret[0].data[i].id, pic: ret[0].data[i].thumb ? ret[0].data[i].thumb : 'static/images/moren.jpg', title: ret[0].data[i].title})
        for (let i = 5; i < 15; i++)
          this.newsKYZXListdata.push({id: ret[0].data[i].id, pic: ret[0].data[i].thumb ? ret[0].data[i].thumb : 'static/images/moren.jpg', title: ret[0].data[i].title, introduce: ret[0].data[i].introduce})
        ret[0].data.forEach(item => this.readingdata.push({id: item.id, title: item.title, time: item.addtime, hits: item.hits}))
        this.readingdata = this.readingdata.sort(arrayFun.compareBtoS('hits'))
      })
    },
    /**
     * 获取数据共享数据
     */
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      //筛选条件
      let exp = ''
      if (this.LeiBie !== '')
        exp += `catid = ${this.LeiBie} and `
      if (this.GuoJia !== '')
        exp += `countryname = '${this.GuoJia}' and `
      if (this.LeiXing !== '')
        exp += `filetype = '${this.LeiXing}' and `
      if (this.Input !== '')
        exp += `title like '%${this.Input}%' and examine = 0 and `
      exp = exp ? `${exp}id != 0` : 'id>0'
      let paras = {cmd: 'query', _major: 11, _minor: 22, _exp: exp, orderby: 'addtime DESC', init: 0, pageno: `${currentPage}`, pagesize: `${count}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.cardlist = []
        ret[0].data.forEach(e =>
        {
          this.cardlist.push({id: e.id, src: e.thumb ? e.thumb : 'static/images/moren.jpg', country: e.countryname, title: e.title, sjmc: e.zhdataname, language: e.language, keyword: e.tag, source: e.datastorage, update: e.addtime})
        })
      })
    },
    getSjgx(each)
    {
      let url = this.$router.resolve({path: '/SjgxDetails', query: {id: each.id}})
      window.open(url.href, '_blank')
    },
    // 根据分类的不同层级(是否有下一层级)，跳转到不同的页面
    goTo(catid)
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid=32'}
      window.post.getPost(paras).then((ret) =>
      {
        let bool1 = ret.some(item =>
        {
          return catid === parseInt(item.glid)
        })
        if (bool1 === true)
        {
          let temp = []
          ret.forEach(item =>
          {
            if (parseInt(item.glid) === catid) temp.push(item)
          })
          let bool2 = ret.some(item =>
          {
            return temp[0].id === parseInt(item.glid)
          })
          if (bool2 === true)
          {
            let url = this.$router.resolve({path: '/ZlkTabsList1', query: {catid: catid}})
            window.open(url.href, '_blank')
          }
          else
          {
            let url = this.$router.resolve({path: '/ZlkListDouble', query: {catid: catid}})
            window.open(url.href, '_blank')
          }
        }
        else
        {
          let url = this.$router.resolve({path: '/ZlkList', query: {catid: catid}})
          window.open(url.href, '_blank')
        }
      })
    },
    // 跳转到资料库详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到资料库关键词搜索页面
    goKeywords(item)
    {
      let obj = {keyword: '', catid: '', sort: '', ssgj: item.value}
      let url = this.$router.resolve({path: '/ZlkKeywords', query: obj})
      window.open(url.href, '_blank')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    search()
    {
      this.getList()
      this.handleSizeChange(this.count)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Zlk.vue